import React from "react";
import "./PrivacyPolicy.css"; // You can use the same Home.css or create a separate CSS file if needed.

function PrivacyPolicy() {
  return (
    <div className="container">
      <header>
        <div>
          <h1 className="main-title">Benmed</h1>
        </div>
        <h2 className="subtitle">Privacy Policy</h2>
      </header>

      <section className="privacy-section">
        <h2 className="section-title">Introduction</h2>
        <p>
          Welcome to the Privacy Policy of Benmed Technologies Limited. We are committed to safeguarding your personal data and respecting your privacy. This policy outlines how we collect, use, and protect your information when you use our applications and services.
        </p>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">How We Collect Data</h2>
        <p>
          We collect user data only when it is necessary to authorize app usage or to store user data essential for app functionality. All user data is collected on a secure and encrypted remote server located in the UK.
        </p>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">What We Collect</h2>
        <ul>
          <li>Email address for login to apps with personal data functionality.</li>
          <li>User-generated data, e.g., logbook cases.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">What We Do With This Data</h2>
        <p>We use the information we gather to:</p>
        <ul>
          <li>Provide logbook functionality for users, including updating, editing, deleting, and exporting cases.</li>
          <li>Respond to requests for product information; we do not engage in direct marketing.</li>
          <li>Avoid any automated processing or decision-making, including profiling.</li>
          <li>Ensure that no personal data is transferred outside the European Economic Area.</li>
          <li>Maintain a cookie-free website.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">Keeping Data Secure</h2>
        <p>
          We are committed to ensuring that your data is secure. User data is stored on an encrypted remote server, and user authentication processes minimize the risk of unauthorized access to your information.
        </p>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">Your Rights</h2>
        <p>You have the following rights regarding your personal data:</p>
        <ul>
          <li>
            <strong>Access:</strong> You may request details of the personal information we hold about you free of charge.
          </li>
          <li>
            <strong>Correction:</strong> You may request that we correct any errors in your personal data.
          </li>
          <li>
            <strong>Erasure:</strong> You may request the deletion of your personal data if there is no good reason for us to continue holding it.
          </li>
          <li>
            <strong>Restriction:</strong> You may request that we restrict or stop processing your personal data unless necessary to provide you with goods or services, comply with legal obligations, or in relation to legal claims.
          </li>
          <li>
            <strong>Data Portability:</strong> You may request the transfer of your personal data to another party.
          </li>
        </ul>
        <p>
          To exercise these rights, please contact us at <a href="mailto:ben@benmed.org">ben@benmed.org</a>. You may be asked to provide proof of your identity. Additionally, you have the right to lodge a complaint with the Information Commissioner’s Office at any time.
        </p>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">Contact</h2>
        <p>
          For any questions or concerns regarding this Privacy Policy, please contact us at:
        </p>
        <p>
          <a href="mailto:ben@benmed.org">ben@benmed.org</a>
        </p>
      </section>

      <section className="privacy-section">
        <h2 className="section-title">Changes to This Policy</h2>
        <p>
          Benmed Technologies Limited will review this policy at regular intervals. We reserve the right to update or amend it at any time. This policy is intended to be fully compliant with data protection legislation. In the event of any conflict between this policy and data protection laws, we will adhere to the data protection legislation.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;